var map = {
	"./_default.json": 443,
	"./ancot.json": 444,
	"./bmarken.json": 445,
	"./cittaviva.json": 446,
	"./class.json": 447,
	"./coop.json": 448,
	"./crai.json": 449,
	"./csp.json": 450,
	"./doreca.json": 451,
	"./doro.json": 452,
	"./ekom.json": 453,
	"./enel.json": 454,
	"./fashionzclub.json": 455,
	"./gdsp.json": 456,
	"./goovi.json": 457,
	"./lcng.json": 458,
	"./lie.json": 459,
	"./mauto.json": 460,
	"./mysarca.json": 461,
	"./retail.json": 462,
	"./retex-bistrot.json": 463,
	"./retex.json": 464,
	"./self-service.json": 465,
	"./smarttouch.json": 466,
	"./smkt.json": 467,
	"./voghera.json": 468,
	"./wikimuseo.json": 469
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 831;